import { getInvitedUserDetails } from '@/api/user';
import { useApiQuery } from '@/hooks/api';
import { queryKeys } from '@/shared/lib/queryKeys';

import type { InvitedUserDetails } from '@/types/user';

export function useInvitedUserDetails(
  uid: string,
  token: string,
  profileId: string | null,
  options?: { enabled?: boolean },
) {
  return useApiQuery<InvitedUserDetails>({
    queryKey: queryKeys.user.invitedDetails(uid, token, profileId),
    queryFn: () => getInvitedUserDetails(uid, token, profileId),
    enabled: Boolean(uid && token) && (options?.enabled ?? true),
    retry: false,
  });
}
